export default "__VITE_ASSET__Cnd_Y$42__"